var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 106 102",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4266 3.24468L64.8197 35.2315C65.4222 37.0856 67.15 38.3409 69.0995 38.3409H102.732C104.186 38.3409 104.79 40.2004 103.614 41.0545L76.4045 60.8234C74.8273 61.9693 74.1673 64.0005 74.7698 65.8546L85.1629 97.8414C85.612 99.2234 84.0302 100.373 82.8547 99.5185L55.645 79.7495C54.0678 78.6036 51.9322 78.6036 50.355 79.7495L23.1453 99.5185C21.9698 100.373 20.388 99.2234 20.8371 97.8414L31.2302 65.8546C31.8327 64.0005 31.1727 61.9693 29.5955 60.8234L2.38587 41.0545C1.2103 40.2004 1.81446 38.3409 3.26755 38.3409H36.9005C38.85 38.3409 40.5778 37.0856 41.1803 35.2315L51.5734 3.24468C52.0224 1.86271 53.9776 1.86271 54.4266 3.24468Z",
    fill: "#e0be79",
    stroke: "black",
    strokeWidth: 6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dac77f16.svg";
export { ForwardRef as ReactComponent };